module.exports = __webpack_public_path__ + "img/format_bold.a6bac428.svg";